import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./BackTop.module.css";
import { ReactComponent as BackTopIcon } from "../../assets/svg/backtop.svg";
import { t } from "../../utils/i18n";

const BackTop = () => {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const [scrollContainer, setScrollContainer] = useState(null);

  // Find the scrollable element based on current route/layout
  useEffect(() => {
    const findScrollContainer = () => {
      // 1. Try to find main element first (most common case for Home)
      const mainElement = document.querySelector("main");
      if (mainElement && mainElement.scrollHeight > mainElement.clientHeight) {
        console.log("BackTop: Found scrollable main element");
        return mainElement;
      }

      // 2. Check if window scrolls
      if (document.documentElement.scrollHeight > window.innerHeight) {
        console.log("BackTop: Using window scroll");
        return window;
      }

      // 3. Check for specific known scroll containers based on route
      const homeMain = document.querySelector('main[class*="main"]');
      if (homeMain && homeMain.scrollHeight > homeMain.clientHeight) {
        console.log("BackTop: Found Home main");
        return homeMain;
      }

      // Browse page might use window or a specific div
      const browseContent = document.querySelector(
        'div[class*="browseContent"]',
      );
      if (
        browseContent &&
        browseContent.scrollHeight > browseContent.clientHeight
      ) {
        console.log("BackTop: Found Browse content");
        return browseContent;
      }

      // GamePage might use window or specific div
      const gamePageContent = document.querySelector(
        'div[class*="gamepageContent"]',
      );
      if (
        gamePageContent &&
        gamePageContent.scrollHeight > gamePageContent.clientHeight
      ) {
        console.log("BackTop: Found GamePage content");
        return gamePageContent;
      }

      // Fallback to window
      console.log("BackTop: Fallback to window");
      return window;
    };

    // Give a small delay for DOM to render/layout
    const timer = setTimeout(() => {
      const container = findScrollContainer();
      setScrollContainer(container);
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  useEffect(() => {
    if (!scrollContainer) return;

    const handleScroll = () => {
      let scrollTop = 0;
      if (scrollContainer === window) {
        scrollTop = window.scrollY || document.documentElement.scrollTop;
      } else {
        scrollTop = scrollContainer.scrollTop;
      }
      setShow(scrollTop > 300);
    };

    scrollContainer.addEventListener("scroll", handleScroll);
    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, [scrollContainer]);

  const scrollToTop = () => {
    if (!scrollContainer) return;

    if (scrollContainer === window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // If not visible, don't render (or render hidden class)
  // But we use CSS for display logic too

  return (
    <div
      className={`${styles.backTop} ${show ? styles.show : ""}`}
      onClick={scrollToTop}
      aria-label={t("backTop.aria", "Back to Top")}
    >
      <BackTopIcon className={styles.icon} />
    </div>
  );
};

export default BackTop;
